import contract from '@mailobj-browser/front/js/contracts/contract.js'
import mains from './mains/mains.js'
import menu from './menu/menu.js'

export default contract({
  mains,
  menu
})
